import React, { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import api from '@/lib/api';
import { TrendingUp } from 'lucide-react';

export default function MetricCardWidget({ widget }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
    
    // Auto-refresh a cada 30 segundos
    const interval = setInterval(loadData, 30000);
    return () => clearInterval(interval);
  }, [widget.id]);

  const loadData = async () => {
    try {
      const { data: result } = await api.get(`/dashboards/widgets/${widget.id}/data`);
      setData(result || []);
    } catch (error) {
      console.error('Erro ao carregar dados do widget:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Card className="p-4 h-full flex items-center justify-center">
        <div className="text-slate-400">Carregando...</div>
      </Card>
    );
  }

  const value = data?.[0]?.value || 0;

  return (
    <Card className="p-5 h-full border-slate-200">
      <div className="flex items-start justify-between h-full">
        <div>
          <div className="text-sm text-slate-500">{widget.title}</div>
          <div className="text-3xl font-bold text-slate-900 mt-2">{value}</div>
        </div>
        <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-blue-50 text-blue-600">
          <TrendingUp className="w-6 h-6" />
        </div>
      </div>
    </Card>
  );
}
